module.exports = __webpack_public_path__ + "static/media/agder_mark-konig-NU5hB3RI5mY-unsplash.ff9e586e.jpg";